





















import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class ThDropdown extends Vue {
    @Prop({
        type: String,
        default: ""
    })
    thText?: string;

    @Prop({
        type: Array,
        default: []
    })
    dropList?: DataTable.DropItem[];

    @Prop({
        type: [Object, String]
    })
    activeMenu?: DataTable.DropItem;

    handleCommand(item: DataTable.DropItem) {
        this.$emit("update:activeMenu", item);
        this.$emit("change", item);
    }
}
